import React from 'react';
import SupplierLayout from '../../layouts/SupplierLayout';
import AllProforma from '../../components/Tables/AllProforma';

const ProformaPage = () => {
	return (
		<SupplierLayout>
			<AllProforma />
		</SupplierLayout>
	);
};
export default ProformaPage;
